import { Component, Input } from '@angular/core';
import { ActivityNotificationService } from '../activity-notification.service';

@Component({
  selector: 'lp2-activity-subtle-notification',
  templateUrl: './activity-subtle-notification.component.html',
  styleUrls: ['./activity-subtle-notification.component.scss'],
})
export class ActivitySubtleNotificationComponent {
  @Input()
  overTheLimitActivity: boolean;

  constructor(
    private activityNotificationService: ActivityNotificationService
  ) {}

  openModalNotification() {
    this.activityNotificationService.showModalNotification();
  }

  close() {
    this.activityNotificationService.removeSubtleNotification(true);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/activity-notification/activity-subtle-notification/activity-subtle-notification.component.ts